module.exports = __webpack_public_path__ + "static/img/fuli_pc1.ccd26815.jpg";